<template>
  <div class="row">
    <div class="col-12">
      <card v-if="isIndex()" class="custom-shadow-card-header">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfLots="false"
              :filterOfFarms="false"
            >
              <template slot="prev">
                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.type') }}: *</label>
                  <el-select
                    v-model="filters.report_type"
                    class="select-primary w-100 shadow-sm"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="clearReport"
                  >
                    <el-option
                      label="Detallado"
                      value="detailed"
                      class="select-primary"
                    />
                    <el-option
                      label="Consolidado"
                      value="consolidated"
                      class="select-primary"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.farm') }} *</label>
                  <el-select
                    v-model="filters.farm_id"
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="onFarmChange"
                  >
                    <el-option
                      v-for="farm in farms"
                      :key="farm.id"
                      :value="farm.id"
                      :label="farm.name"
                      class="select-primary"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.section') }}</label>
                  <el-select
                    v-model="filters.section_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="!filters.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filters.section_ids', sections);
                      onSectionsChange();
                    "
                  >
                    <el-option
                      v-for="section in concatAll(sections)"
                      :key="section.id"
                      :value="section.id"
                      :label="section.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('irrigation.block') }}</label>
                  <el-select
                    v-model="filters.block_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="!filters.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filters.block_ids', blocks);
                      onBlocksChange();
                    "
                  >
                    <el-option
                      v-for="block in concatAll(blocks)"
                      :key="block.id"
                      :value="block.id"
                      :label="block.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.variety') }}</label>
                  <el-select
                    v-model="filters.crop_variety_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="!filters.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect(
                        'filters.crop_variety_ids',
                        varieties
                      );
                      onVarietiesChange();
                    "
                  >
                    <el-option
                      v-for="variety in concatAll(varieties)"
                      :key="variety.id"
                      :value="variety.id"
                      :label="variety.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.bed') }}</label>
                  <el-select
                    v-model="filters.bed_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="!filters.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filters.bed_ids', beds);
                      onBedsChange();
                    "
                  >
                    <el-option
                      v-for="bed in concatAll(beds)"
                      :key="bed.id"
                      :value="bed.id"
                      :label="bed.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('common_words.valve') }}</label>
                  <el-select
                    v-model="filters.valve_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="!filters.farm_id"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect('filters.valve_ids', valves);
                      onValvesChange();
                    "
                  >
                    <el-option
                      v-for="valve in concatAll(valves)"
                      :key="valve.id"
                      :value="valve.id"
                      :label="valve.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>

                <div class="col-12 col-md-6 col-lg-3 mb-3">
                  <label>{{ $t('devices.blood_pressure_monitors') }}</label>
                  <el-select
                    v-model="filters.blood_pressure_monitor_ids"
                    multiple
                    collapse-tags
                    clearable
                    filterable
                    class="select-primary w-100 shadow-sm"
                    :disabled="filters.valve_ids.length === 0"
                    :placeholder="`${$t('common_words.select')}...`"
                    @change="
                      selectAllFromSelect(
                        'filters.blood_pressure_monitor_ids',
                        filteredMonitors
                      );
                      clearReport();
                    "
                  >
                    <el-option
                      v-for="monitor in concatAll(filteredMonitors)"
                      :key="monitor.id"
                      :value="monitor.id"
                      :label="monitor.name"
                      class="select-primary selected-all"
                    />
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>

      <not-index-permissions v-else />

      <template v-if="showReport && isIndex()">
        <card>
          <div class="row">
            <div class="col-12 col-md-4 mb-3">
              <kpi
                :label="$t('common_words.average')"
                :value="formatKpi(summary.average)"
              >
                <template slot="unit"> kPa</template>
              </kpi>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <kpi
                :label="$t('common_words.minimum')"
                :value="formatKpi(summary.minimum)"
              >
                <template slot="unit"> kPa</template>
              </kpi>
            </div>
            <div class="col-12 col-md-4 mb-3">
              <kpi
                :label="$t('common_words.maximum')"
                :value="formatKpi(summary.maximum)"
              >
                <template slot="unit"> kPa</template>
              </kpi>
            </div>
          </div>
        </card>

        <card>
          <highcharts :options="chartOptions" />
        </card>
        <card
          class="custom-shadow-card-header"
          :title="
            filters.report_type === 'detailed'
              ? $t('irrigation.detailed_report')
              : $t('irrigation.consolidated_report_by_depth')
          "
        >
          <card-header
            ref="tableHeader"
            :propPagination="pagination"
            class="mr-3 mt-4"
            @searchedQuery="handleSearchQuery"
          />
          <div class="table-responsive">
            <el-table
              :data="queriedData"
              border
              stripe
              style="width: 100%"
              max-height="600"
              empty-text="No hay información para los filtros seleccionados"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.prop || column.label"
                :prop="column.prop"
                :label="column.label"
                :min-width="column.minWidth"
                :align="column.align || 'center'"
                :sortable="column.sortable !== false"
              >
                <el-table-column
                  v-for="child in column.children || []"
                  :key="child.prop"
                  :prop="child.prop"
                  :label="child.label"
                  :min-width="child.minWidth"
                  :align="child.align || 'center'"
                  :sortable="child.sortable !== false"
                />
              </el-table-column>
            </el-table>
          </div>
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <export-tables
            :pdf="{
              filename: '',
              route: '',
              showPDFButton: false,
            }"
            :xls="{
              filename: excelFilename,
              route: excelRoute,
              paramMethod: 'POST',
              plusData: { ...getDataToExport },
            }"
          />
        </card>
      </template>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import Kpi from 'src/views/Layouts/Kpi.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinCharts from 'src/util/mixinCharts';
import mixinMasters from 'src/util/mixinMasters';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';
import { isset } from 'src/util/Util.js';
import Filter from 'src/components/Filter/Filters.vue';
import configTable, { depthProperty } from './blood-pressure-monitors-table';

exportingInit(Highcharts);

export default {
  name: 'BloodPressureMonitorReport',
  components: {
    [Filter.name]: Filter,
    Kpi,
    highcharts: Chart,
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMenu,
    MixinPermissions,
    MixinCharts,
    mixinMasters,
  ],
  data() {
    return {
      activeName: 'filter',
      farms: [],
      farmConfiguration: null,
      monitors: [],
      showReport: false,
      summary: { average: 0, minimum: 0, maximum: 0 },
      tableData: [],
      tableColumns: [...Tables.Table.tableColumns],
      pagination: { ...Tables.Table.pagination },
      depths: [],
      chartOptions: {},
      dataFilter: {
        bySel: null,
        datei: null,
        datef: null,
      },
      filters: {
        farm_id: null,
        report_type: 'detailed',
        section_ids: [],
        block_ids: [],
        crop_variety_ids: [],
        bed_ids: [],
        valve_ids: [],
        blood_pressure_monitor_ids: [],
      },
    };
  },
  computed: {
    excelFilename() {
      const reportName =
        this.filters.report_type === 'detailed'
          ? this.$t('irrigation.detailed_report')
          : this.$t('irrigation.consolidated_report_by_depth');
      return `${reportName}_${this.dataFilter.datei}_${this.dataFilter.datef}.xlsx`;
    },
    excelRoute() {
      return `irrigation/reports/bloodpressuremonitors/${this.filters.report_type}/excel`;
    },
    getDataToExport() {
      return {
        data: this.tableData,
        bySel: this.dataFilter.bySel,
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    relations() {
      if (!this.farmConfiguration) return [];
      const relations =
        this.farmConfiguration.sections_rel ||
        this.farmConfiguration.sections ||
        [];
      return Array.isArray(relations)
        ? relations.filter((relation) => relation && !relation.deleted_at)
        : [];
    },
    sections() {
      return this.uniqueOptions(
        this.relations.map((relation) => this.sectionOption(relation))
      );
    },
    blocks() {
      return this.uniqueOptions(
        this.filterRelations({ section: true }).reduce((options, relation) => {
          return options.concat(this.blockOptions(relation));
        }, [])
      );
    },
    varieties() {
      return this.uniqueOptions(
        this.filterRelations({ section: true, block: true }).map((relation) =>
          this.varietyOption(relation)
        )
      );
    },
    beds() {
      return this.uniqueOptions(
        this.filterRelations({ section: true, block: true, variety: true }).map(
          (relation) => this.bedOption(relation)
        )
      );
    },
    valves() {
      return this.uniqueOptions(
        this.filterRelations({
          section: true,
          block: true,
          variety: true,
          bed: true,
        }).map((relation) => this.valveOption(relation))
      );
    },
    filteredMonitors() {
      return this.monitors.filter((monitor) => {
        const valveId = monitor.valve_id || (monitor.valve && monitor.valve.id);
        return this.filters.valve_ids.some((id) => id == valveId);
      });
    },
  },

  watch: {
    '$i18n.locale': 'setupTable',
    'filters.report_type': 'setupTable',
  },

  methods: {
    setupTable() {
      const table = configTable(this.filters.report_type, this.depths).Table;
      this.tableColumns = [...table.tableColumns];
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    normalizeData(response) {
      return response && response.data ? response.data.data : null;
    },

    option(id, name) {
      return isset(id) && name ? { id, name } : null;
    },

    uniqueOptions(options) {
      const unique = [];
      options.filter(Boolean).forEach((option) => {
        if (!unique.some((item) => item.id == option.id)) unique.push(option);
      });
      return unique;
    },

    sectionOption(relation) {
      const section = relation.section || {};
      return this.option(
        relation.section_id || section.id || relation.id,
        relation.section_name || relation.name || section.name
      );
    },

    blockOptions(relation) {
      const blocks = Array.isArray(relation.blocks) ? relation.blocks : [];
      return blocks
        .map((block) =>
          typeof block === 'string'
            ? this.option(block, block)
            : this.option(block.id || block.block_id, block.name)
        )
        .filter(Boolean);
    },

    varietyOption(relation) {
      const variety =
        relation.cropVariety || relation.crop_variety || relation.variety || {};
      return this.option(
        relation.crop_variety_id || variety.id,
        relation.crop_variety_name || variety.name
      );
    },

    bedOption(relation) {
      const bed = relation.bed || {};
      return this.option(
        relation.bed_id || bed.id,
        relation.bed_name || bed.name
      );
    },

    valveOption(relation) {
      const valve = relation.valve || {};
      return this.option(
        relation.valve_id || valve.id,
        relation.valve_name || valve.name
      );
    },

    includesSelected(selected, value) {
      return selected.length === 0 || selected.some((id) => id == value);
    },

    relationHasBlock(relation) {
      const ids = this.blockOptions(relation).map((block) => block.id);
      return (
        this.filters.block_ids.length === 0 ||
        ids.some((id) =>
          this.filters.block_ids.some((selected) => selected == id)
        )
      );
    },

    filterRelations(levels) {
      return this.relations.filter((relation) => {
        const section = this.sectionOption(relation);
        const variety = this.varietyOption(relation);
        const bed = this.bedOption(relation);
        return (
          (!levels.section ||
            (section &&
              this.includesSelected(this.filters.section_ids, section.id))) &&
          (!levels.block || this.relationHasBlock(relation)) &&
          (!levels.variety ||
            (variety &&
              this.includesSelected(
                this.filters.crop_variety_ids,
                variety.id
              ))) &&
          (!levels.bed ||
            (bed && this.includesSelected(this.filters.bed_ids, bed.id)))
        );
      });
    },

    clearReport() {
      this.showReport = false;
      this.tableData = [];
      this.depths = [];
      this.chartOptions = {};
      this.summary = { average: 0, minimum: 0, maximum: 0 };
      this.searchQuery = '';
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.pagination.total = 0;
      this.fuseSearch = null;
      if (this.$refs.tableHeader) this.$refs.tableHeader.searchQuery = '';
    },

    handleSearchQuery(query) {
      this.searchQuery = query;
      this.pagination.currentPage = 1;
    },

    tableSearchKeys() {
      return this.tableColumns.reduce((keys, column) => {
        if (column.prop) keys.push(column.prop);
        (column.children || []).forEach((child) => keys.push(child.prop));
        return keys;
      }, []);
    },

    resetOptions(keys) {
      keys.forEach((key) => {
        this.filters[key] = [];
      });
      this.clearReport();
    },

    onSectionsChange() {
      this.resetOptions([
        'block_ids',
        'crop_variety_ids',
        'bed_ids',
        'valve_ids',
        'blood_pressure_monitor_ids',
      ]);
    },

    onBlocksChange() {
      this.resetOptions([
        'crop_variety_ids',
        'bed_ids',
        'valve_ids',
        'blood_pressure_monitor_ids',
      ]);
    },

    onVarietiesChange() {
      this.resetOptions(['bed_ids', 'valve_ids', 'blood_pressure_monitor_ids']);
    },

    onBedsChange() {
      this.resetOptions(['valve_ids', 'blood_pressure_monitor_ids']);
    },

    onValvesChange() {
      this.resetOptions(['blood_pressure_monitor_ids']);
    },

    resetFarmData() {
      this.farmConfiguration = null;
      this.monitors = [];
      this.resetOptions([
        'section_ids',
        'block_ids',
        'crop_variety_ids',
        'bed_ids',
        'valve_ids',
        'blood_pressure_monitor_ids',
      ]);
    },

    onFarmChange(farmId) {
      this.resetFarmData();
      if (!farmId) return;
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters(`farms/farms/configuration/${farmId}`),
        Axios.getMasters(`devices/bloodpressuremonitors?farm_id=${farmId}`),
      ])
        .then(([configurationResponse, monitorsResponse]) => {
          this.farmConfiguration =
            this.normalizeData(configurationResponse) || {};
          this.monitors = this.normalizeData(monitorsResponse) || [];
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    validateFilters() {
      if (!this.filters.farm_id) {
        SweetAlert.warning(i18n.t('irrigation.select_farm'));
        return false;
      }
      if (!this.filters.report_type) {
        SweetAlert.warning(i18n.t('irrigation.select_report_type'));
        return false;
      }
      if (String(this.dataFilter.datei) > String(this.dataFilter.datef)) {
        SweetAlert.warning(i18n.t('irrigation.invalid_date_range'));
        return false;
      }
      return true;
    },

    handleFilter(filterData) {
      this.dataFilter = {
        bySel: filterData.bySel,
        datei: filterData.datei,
        datef: filterData.datef,
      };
      this.filterReport();
    },

    filterReport() {
      if (!this.validateFilters()) return;
      this.clearReport();
      this.showHideLoading(true);
      Axios.postMasters({
        route: 'irrigation/reports/bloodpressuremonitors',
        farm_id: this.filters.farm_id,
        report_type: this.filters.report_type,
        section_ids: this.filters.section_ids,
        block_ids: this.filters.block_ids,
        crop_variety_ids: this.filters.crop_variety_ids,
        bed_ids: this.filters.bed_ids,
        valve_ids: this.filters.valve_ids,
        blood_pressure_monitor_ids: this.filters.blood_pressure_monitor_ids,
        ...this.dataFilter,
      })
        .then((response) => {
          const data = this.normalizeData(response) || {};
          const rows = data.table_data || data.rows || [];
          this.depths = this.normalizeDepths(
            data.depths || data.depth_headers || [],
            rows
          );
          this.setupTable();
          this.tableData = this.normalizeRows(rows);

          if (this.tableData.length === 0) {
            this.showReport = false;
            this.showHideLoading();
            SweetAlert.warning(this.$t('common_words.unavailable_data'));
            return;
          }

          this.summary = this.normalizeSummary(data.summary || data.kpis || {});
          this.chartOptions = this.buildChart(data.chart_data || {});
          this.pagination.perPage = 10;
          this.pagination.currentPage = 1;
          this.pagination.total = this.tableData.length;
          this.searchFuse(this.tableSearchKeys(), this.tableData);
          this.showReport = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    normalizeSummary(summary) {
      return {
        average: this.firstDefined([
          summary.average,
          summary.avg,
          summary.promedio,
          0,
        ]),
        minimum: this.firstDefined([
          summary.minimum,
          summary.min,
          summary.minimo,
          0,
        ]),
        maximum: this.firstDefined([
          summary.maximum,
          summary.max,
          summary.maximo,
          0,
        ]),
      };
    },

    firstDefined(values) {
      return values.find((value) => value !== undefined && value !== null);
    },

    normalizeDepths(depthHeaders, rows) {
      const depths = (Array.isArray(depthHeaders) ? depthHeaders : []).map(
        (depth) =>
          typeof depth === 'object'
            ? this.firstDefined([depth.depth, depth.value, depth.name])
            : depth
      );
      rows.forEach((row) => {
        const values =
          row.depth_values || row.values_by_depth || row.values || null;
        if (values && !Array.isArray(values)) {
          Object.keys(values).forEach((depth) => depths.push(depth));
        }
        const rowDepth = this.firstDefined([
          row.depth,
          row.depth_cm,
          row.profundidad,
        ]);
        if (rowDepth !== undefined) depths.push(rowDepth);
      });
      return depths
        .filter(
          (depth, index, list) =>
            list.findIndex((item) => String(item) === String(depth)) === index
        )
        .sort((first, second) => Number(first) - Number(second));
    },

    consolidatedBaseRow(row) {
      return {
        date: this.firstDefined([row.date, row.date_save, row.fecha]),
        farm: this.firstDefined([row.farm, row.farm_name, row.finca]),
        user: this.firstDefined([row.user, row.user_name, row.usuario]),
        section: this.firstDefined([
          row.section,
          row.section_name,
          row.seccion,
        ]),
        block: this.firstDefined([row.block, row.block_name, row.bloque]),
        variety: this.firstDefined([
          row.variety,
          row.crop_variety_name,
          row.variedad,
        ]),
        bed: this.firstDefined([row.bed, row.bed_name, row.cama]),
        valve: this.firstDefined([row.valve, row.valve_name, row.valvula]),
      };
    },

    normalizeRows(rows) {
      if (!Array.isArray(rows)) return [];
      if (this.filters.report_type === 'detailed') {
        return rows.map((row) => ({
          ...this.consolidatedBaseRow(row),
          blood_pressure_monitor: this.firstDefined([
            row.blood_pressure_monitor,
            row.monitor_name,
            row.tensiometro,
          ]),
          depth: this.firstDefined([row.depth, row.depth_cm, row.profundidad]),
          value: this.firstDefined([row.value, row.valor]),
        }));
      }
      const grouped = {};
      rows.forEach((row) => {
        const base = this.consolidatedBaseRow(row);
        const key = JSON.stringify(base);
        if (!grouped[key]) grouped[key] = { ...base };

        const values =
          row.depth_values || row.values_by_depth || row.values || null;
        if (values && !Array.isArray(values)) {
          Object.keys(values).forEach((depth) => {
            grouped[key][depthProperty(depth)] = values[depth];
          });
        }

        this.depths.forEach((depth) => {
          const property = depthProperty(depth);
          if (row[property] !== undefined && row[property] !== null) {
            grouped[key][property] = row[property];
          }
        });

        const depth = this.firstDefined([
          row.depth,
          row.depth_cm,
          row.profundidad,
        ]);
        const value = this.firstDefined([
          row.value,
          row.valor,
          row.average,
          row.avg,
          row.promedio,
        ]);
        if (depth !== undefined && value !== undefined) {
          grouped[key][depthProperty(depth)] = value;
        }
      });
      return Object.values(grouped);
    },

    buildChart(chartData) {
      if (chartData && chartData.series && chartData.xAxis) return chartData;
      return this.lines(chartData, true, 'auto', false, true);
    },

    formatKpi(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number.toFixed(2) : '0.00';
    },
  },

  created() {
    this.setupTable();
    this.showHideLoading(true);
    Axios.getMasters('farms/farms/only')
      .then((response) => {
        this.farms = this.normalizeData(response) || [];
        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });
  },
  mounted() {
    this.selectedItemOnMenu('irrigation');
  },
  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>

<style scoped>
::v-deep .card-title {
  font-weight: 400;
}

.table-responsive {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
